var Application = require('./application');
Application.initialize();
